import { Skeleton } from 'antd';
import InfoText from '../atoms/InfoText';
import { Trash } from 'iconsax-react';

export interface ChangeBoxProps {
  value: string;
  isLoading?: boolean;
}

export const DeleteHeader: React.FC<ChangeBoxProps> = ({
  value,
  isLoading,
}) => {
  return (
    <div
      className={`bg-[#FAF2F3] border border-[#CC2936] rounded-2xl px-6 py-4 flex items-center gap-x-4`}
    >
      <div className="p-3 bg-light-warning rounded-xl">
        <Trash size={20} variant="Bold" className="text-white" />
      </div>
      {isLoading ? (
        <Skeleton.Input
          active
          size="small"
          style={{ width: 100, height: 20 }}
        />
      ) : (
        <InfoText
          text={String(value)}
          className="text-lg font-bold text-gray-900"
        />
      )}
    </div>
  );
};

export default DeleteHeader;
